import { useUser } from "@/hooks/useUser";

export function HomePage() {
  const { data: user, isLoading, error } = useUser();

  if (isLoading) return <p className="text-ink-muted">Carregando perfil…</p>;
  if (error)
    return (
      <div className="card p-6">
        <h2 className="font-display text-lg font-semibold">Sem provisionamento</h2>
        <p className="mt-2 text-sm text-ink-muted">
          Seu usuário do Entra ID autenticou mas não pertence a nenhum grupo APP-ASO-*.
          Sabrina (DGL) precisa adicionar você ao grupo do papel correto.
        </p>
      </div>
    );

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-semibold text-ink">Bem-vinda, {user?.nome}</h2>
        <p className="text-sm text-ink-muted">
          Você está autenticada como <span className="font-medium text-anarosa">{user?.papel}</span>.
        </p>
      </div>

      <div className="card p-6">
        <h3 className="font-display text-base font-semibold">Atalhos</h3>
        <p className="mt-1 text-sm text-ink-muted">
          Use o menu lateral pra navegar. Cadastros (Empresas, Colaboradores, Médicos) já
          funcionam; Documentos, Atendimentos, ASOs e Pendências estão em construção —
          entrega na próxima rodada.
        </p>
      </div>
    </div>
  );
}
